<template>
  <div class="header">
    <div class="header-head flex-between-center">
      <p>您好，欢迎来到恒鑫网~</p>
      <div class="flex-center-lr">
				<template v-if="loginInfo.hasLogin&&userInfo.account">
					欢迎您，
          <el-dropdown>
            <span class="user-name" @click="$router.push('/personal')">
              <img class="user-avatar" src="../assets/img/avatar.png">
              <span>{{ userInfo.name || userInfo.account }}<i class="el-icon-arrow-down el-icon--right"></i></span>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="$router.push('/personal')">个人中心</el-dropdown-item>
              <el-dropdown-item @click.native="$router.push('/messageCenter')">消息中心</el-dropdown-item>
              <el-dropdown-item @click.native="logout">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
				</template>
				<template v-else>
					<a @click="toLogin">登录</a>
					<router-link class="color-theme" to="/register">免费注册</router-link>
				</template>
        <!-- <div class="flex-lr">
          <img
            src="../assets/img/tel.png"
            class="header-head-tel"
          />028-85151562
        </div> -->
      </div>
    </div>
    <div class="header-main">
      <div class="min-width flex-center-lr">
        <img
          @click="$router.push('/')"
          src="../assets/img/logo.png"
          class="header-main-logo"
        />
        <template v-if="!welcomeMsg">
          <el-input
            placeholder="请输入内容"
            v-model="searchData"
            @keyup.enter.native="search"
            class="input-with-select"
            v-if="!registerType || registerType&&$route.query.type==2"
          >
            <el-button
              slot="append"
              @click="search"
              icon="el-icon-search"
            ></el-button>
          </el-input>
          <div class="flex_1 flex-center" v-if="registerType&&registerType<4&&$route.query.type!=2">
            <Process
              v-model="registerType"
              :processList="processList"
            ></Process>
          </div>
          <div v-else class="flex_1">
            <slot></slot>
          </div>
            <el-button @click="goCart" class="header-main-cart">
              我的购物车
              <el-badge :value="cartNum" :hidden="cartNum == 0"  class="item">
                <i class="el-icon-shopping-cart-full"></i>
              </el-badge>
            </el-button>
        </template>
        <p class="header-welcome" v-else>{{ welcomeMsg }}</p>
      </div>
    </div>
    <div class="header-stick">
      <el-popover
        placement="left-start"
        width="130"
        trigger="hover"
      >
        <div class="header-stick-item" slot="reference">
          <div></div>
          <p>微信</p>
        </div>
        <div class="qr-con">
          <img src="../assets/img/qr1.jpg">
          <img src="../assets/img/qr2.jpg">
          <p>扫描二维码，添加客服微信</p>
        </div>
      </el-popover>
      <el-popover
        placement="left"
        width="84"
        trigger="hover"
      >
        <div class="header-stick-item item2" slot="reference">
          <div></div>
          <p>电话</p>
        </div>
        <div class="font-16 text-center">4001-878-060</div>
      </el-popover>
    </div>
  </div>
</template>

<script>
import {
  userSilentLogin
} from '@/api/api';
import { $sp_signOut } from '@/api/user';
import { getUserToken, setUserToken } from "@/global/tokenManager";
import Process from "@/components/Process/Process.vue";
import { mapState, mapActions } from 'vuex'
export default {
  name: "Header",
  components: {
    Process,
  },
  data() {
    return {
      searchData: "",
      msgConfig: {
        login: '欢迎登录',
        forget: '找回密码',
        register: '注册新账户',
        privacy: '隐私政策',
        creditRule: '周转额度说明',
        paymentAgreement: '三方代付协议',
      },
      registerType: "",
      processList: [
        { value: 1, name: "1.我的购物车" },
        { value: 2, name: "2.填写核对订单信息" },
        { value: 3, name: "3.成功提交订单" },
      ]
    };
  },
  computed: {
    ...mapState(['cartNum', 'loginInfo', 'userInfo']),
    welcomeMsg({ msgConfig }) {
      return msgConfig[this.$route.name] || ''
    }
  },
  created() {
		if (this.$route.query.keywords) {
      this.searchData = this.$route.query.keywords
		}
		if (this.loginInfo.hasLogin&&getUserToken()) {
			this.updateUserInfo()
		}
    this.updateCartNum()
  },
  mounted() {
    const name = this.$route.name;
    switch (name) {
      case "placeOrder":
        this.registerType = 2;
        break;
      case "payOrder":
        this.registerType = 3;
        break;
      case "payResult":
        this.registerType = 3;
        break;
      case "behalfDetail":
        this.registerType = 4;
        break;
    }
  },
  methods: {
    ...mapActions(['updateCartNum', 'updateUserInfo']),
    search() {
      this.$emit("toSearch", this.searchData);
      this.searchData = "";
    },
    toLogin() {
      this.$toLogin(this.$route.fullPath)
    },
    goCart() {
      this.$router.push({
        name: "cart",
      });
    },
    logout() {
      $sp_signOut().then(() => {
        setUserToken("");
        this.$store.commit('setUserInfo', {})
        userSilentLogin().then(() => {
          if (this.$route.name == 'index') {
            location.reload()
          } else {
            this.$router.replace("/index")
          }
        })
      })
    }
  },
};
</script>

<style scoped lang="scss">
.header {
  background: #f5f6fa;
  min-width: 1200px;
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  z-index: 11;
  &-head {
    height: 42px;
    width: 1200px;
    font-weight: 400;
    font-size: 12px;
    color: #333333;
    line-height: 12px;
    margin: 0 auto;

    & a {
      font-size: 12px;
      &:nth-child(2) {
        margin-left: 24px;
        position: relative;
        &::after {
          content: "";
          width: 0px;
          height: 12px;
          border: 1px solid #d8d8d8;
          position: absolute;
          top: 0;
          left: -12px;
        }
      }
    }
    .user {
      &-avatar {
        width: 20px;
        height: 20px;
        margin: 0 8px;
        vertical-align: middle;
      }
      &-name {
        cursor: pointer;
        font-size: 12px;
        span {
          vertical-align: middle;
        }
      }
    }
    &-tel {
      width: 16px;
      height: 16px;
      margin: 0 8px 0 76px;
    }
  }
  &-main {
    height: 136px;
    background: #FFFFFF url(../assets/img/header-bg.png) no-repeat;
    background-position: center;
    background-size: 2560px 136px;
    min-width: 1200px;
    &-logo {
      width: 206px;
      height: 50px;
      margin-right: 60px;
      cursor: pointer;
    }
    & ::v-deep .el-input {
			&-group {
				width: 648px;
			}
			&__inner {
				border-color: #0060ff;
				border-width: 2px;
        height: 44px;
        line-height: 44px;
			}
			&-group__append {
				padding: 0 28px;
				border-color: #0060ff;
				background: linear-gradient( 180deg, #0090FF 0%, #0035FF 100%);
				color: #fff;
				border-width: 2px;
        font-size: 16px;
			}
		}
    &-cart {
      width: 174px;
      height: 44px;
      line-height: 44px;
      padding: 0;
      color: #0060ff;
      border-color: #EAEAEA;
      font-size: 14px;
      i {
        font-size: 22px;
      }
      ::v-deep.el-badge {
        &__content.is-fixed {
          top: 10px;
          right: 5px;
          padding: 0 4px;
          line-height: 14px;
          height: 14px;
        }
      }
    }
  }
  &-welcome {
    font-size: 24px;
    color: #333333;
  }
  &-stick {
    position: fixed;
    right: 0;
    top: 324px;
    width: 70px;
    background-color: #FFFFFF;
    border-radius: 15px  0px  0px  15px;
    padding-top: 20px;
    &-item {
      padding-bottom: 20px;
      cursor: pointer;
      div {
        width: 40px;
        height: 40px;
        margin: 0 auto 2px;
        background: url('../assets/img/head_icon1.png') no-repeat center/100%;
      }
      &:hover {
        div {
          background-image: url('../assets/img/head_icon11.png');
        }
        p {
          color: #0060FF;
        }
      }
      p {
        text-align: center;
        font-size: 14px;
        color: #3D3D3D;
        line-height: 20px;
      }
      &.item2 div {
        background-image: url('../assets/img/head_icon2.png');
        &:hover {
          background-image: url('../assets/img/head_icon22.png');
        }
      }
    }
  }
}
.qr-con {
  line-height: 16px;
  font-size: 12px;
  text-align: center;
  img {
    display: block;
    width: 130px;
    height: auto;
    margin: 8px auto 12px;
  }
}
</style>
